module.exports = __webpack_public_path__ + "static/media/home_hero_bg.0035e5bd.png";